export const REPORT_SYNC_DEBOUNCE_MS = 2000;
